import type { ReportPlayStatus } from "@meta-video/contracts";
import { Badge } from "@mantine/core";

import { playStatusLabels } from "./playStatus.js";

const statusColors: Readonly<Record<ReportPlayStatus, string>> = {
  hosted: "teal",
  not_tracked: "gray",
  pending: "yellow",
  unavailable: "red",
};

export function StatusBadge({ status }: { readonly status: ReportPlayStatus }) {
  const label = playStatusLabels[status];
  return (
    <Badge
      aria-label={`Playback status: ${label}`}
      color={statusColors[status]}
      size="sm"
      variant="light"
    >
      <span aria-hidden="true">● </span>{label}
    </Badge>
  );
}
